import {translate} from "react-i18nify";

import * as actionTypes from "../constants/actionTypes";
import * as config from "../constants/config";
import * as databaseStatuses from "../constants/databaseStatuses";
import * as rcc from "../constants/rcc";
import * as resultCodes from "../constants/resultCodes";
import * as settings from "../constants/settings";
import * as statsTypes from "../constants/statsTypes";
import * as modelHelper from "./modelHelper";
import * as changelogService from "../services/changelogService";
import * as windowService from "../services/windowService";

export const isGetLicenseStatusFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.status === undefined) {
        return false;
    }

    if (response.data.status === 1) {
        if (response.data.product === undefined) {
            return false;
        }

        if (response.data.modules === undefined || !Array.isArray(response.data.modules)) {
            return false;
        }

        return true;
    }

    if (response.data.status === -1) {
        if (response.data.error === undefined) {
            return false;
        }

        if (response.data.error.message === undefined || response.data.error.code === undefined) {
            return false;
        }

        return true;
    }

    return true;
};

export const isGetLicenseProductsFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (typeof response.data !== "object" || response.data === null) {
        return false;
    }

    return true;
};

export const isGetServerVersionFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.server === undefined || response.data.server.version === undefined) {
        return false;
    }

    return true;
};

export const isGetRedlikeServersFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    return true;
};

export const isGetLoggedUserFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.logged === undefined || response.data.user === undefined) {
        return false;
    }

    if (
        response.data.logged === true &&
        (response.data.user === null ||
            response.data.user.id === undefined ||
            response.data.user.username === undefined ||
            response.data.user.privileges === undefined ||
            typeof response.data.user.privileges !== "object" ||
            response.data.user.currency === undefined ||
            typeof response.data.user.currency !== "object")
    ) {
        return false;
    }

    return true;
};

export const isLoggedUserFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.user === undefined) {
        return false;
    }

    if (
        response.data.user === null ||
        response.data.user.id === undefined ||
        response.data.user.username === undefined ||
        response.data.user.privileges === undefined ||
        typeof response.data.user.privileges !== "object" ||
        response.data.user.currency === undefined ||
        typeof response.data.user.currency !== "object"
    ) {
        return false;
    }

    return true;
};

export const isGetSettingOptionsFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    let options;
    for (options of Object.keys(response.data)) {
        if (!Array.isArray(response.data[options])) {
            return false;
        }
    }

    return true;
};

export const isGetUserSettingsFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    return true;
};

export const isGetUserSettingFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.value === undefined) {
        return false;
    }

    return true;
};

export const isGetPriceSettingFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    return true;
};

export const isGetLastDispensedFormulasFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || !Array.isArray(response.data)) {
        return false;
    }

    return true;
};

export const isGetAllFavoriteFormulasFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data !== undefined || response.data[0] !== undefined) {
        if (response.data[0].nodes === undefined || response.data[0].items === undefined) {
            return false;
        }
    }
    return true;
};

export const isGetAllColorantsFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.colorantList === undefined || !Array.isArray(response.data.colorantList)) {
        return false;
    }

    return true;
};

export const isGetStatisticsValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.stats === undefined) {
        return false;
    }

    return true;
};

export const isGetStatisticsItemsValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.items === undefined) {
        return false;
    }

    return true;
};

export const isAddColorStatsValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.colorStatsId === undefined) {
        return false;
    }

    return true;
};

export const isGroupListFormatValid = (response, groups = true) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (groups) {
        return response.data.nodes !== undefined && response.data.items !== undefined;
    }

    return Array.isArray(response.data);
};

export const isFandeckGroupListFormatValid = (response, groups = true, local = false) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (groups && !local) {
        return response.data.nodes !== undefined && response.data.items !== undefined;
    }

    return Array.isArray(response.data);
};

export const isGetAllProductsSimpleFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || !Array.isArray(response.data)) {
        return false;
    }

    return true;
};

export const isGetAllColorsFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || !Array.isArray(response.data.colorList)) {
        return false;
    }

    return true;
};

export const isGetAllFandecksFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || !Array.isArray(response.data.fandeckList)) {
        return false;
    }

    return true;
};

export const isFormulaListFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (
        response.data.colorCount === undefined ||
        response.data.colorList === undefined ||
        !Array.isArray(response.data.colorList)
    ) {
        return false;
    }

    return true;
};

export const isGetOptionsMenu = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    return true;
};

export const isGetBasesByProductFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.baseList === undefined || !Array.isArray(response.data.baseList)) {
        return false;
    }

    return true;
};

export const isGetMasterProductListFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.zoneSiblings === undefined || !Array.isArray(response.data.zoneSiblings)) {
        return false;
    }

    return true;
};

export const isGetAllCustomFandecksFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.customFandeckList === undefined || !Array.isArray(response.data.customFandeckList)) {
        return false;
    }

    return true;
};

export const isGetAllMarginsFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (
        response.data.marginList === undefined ||
        response.data.marginList.default === undefined ||
        response.data.marginList.custom === undefined
    ) {
        return false;
    }

    if (!Array.isArray(response.data.marginList.default) || !Array.isArray(response.data.marginList.custom)) {
        return false;
    }

    return true;
};

export const isGetMarginForItemFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.absValue === undefined || response.data.proc === undefined) {
        return false;
    }

    return true;
};

export const igGetMarginsForItemsByParamsFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.marginsForItems === undefined) {
        return false;
    }

    return true;
};

export const isGetAllCurrenciesFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (
        response.data === undefined ||
        response.data.currencies === undefined ||
        response.data.currencies.default === undefined ||
        !Array.isArray(response.data.currencies.default) ||
        response.data.currencies.custom === undefined ||
        !Array.isArray(response.data.currencies.custom)
    ) {
        return false;
    }

    return true;
};

export const isGetAllUsersFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    return true;
};

export const isGetAllUnitsFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    return true;
};

export const isGetAllCustomersFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.customerList === undefined || !Array.isArray(response.data.customerList)) {
        return false;
    }

    return true;
};

export const isGetLastCustomersFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data === undefined || !Array.isArray(response.data)) {
        return false;
    }

    return true;
};

export const isGetCustomerFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (
        response.data.id === undefined ||
        response.data.name === undefined ||
        response.data.data === undefined ||
        response.data.margin === undefined
    ) {
        return false;
    }

    return true;
};

export const isAddCustomerFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || response.data.customerId === undefined) {
        return false;
    }

    return true;
};

export const isUserSettingFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || response.data.value === undefined) {
        return false;
    }

    return true;
};

export const isSearchDataFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || !Array.isArray(response.data)) {
        return false;
    }

    return true;
};

export const isBrowseColorsFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || !Array.isArray(response.data)) {
        return false;
    }

    return true;
};

export const isGetDataFromStatsFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (
        response.data.product === undefined ||
        response.data.fandeck === undefined ||
        response.data.color === undefined ||
        response.data.colorInFandeck === undefined ||
        response.data.formula === undefined ||
        response.data.customer === undefined ||
        response.data.baseInProduct === undefined ||
        response.data.base === undefined ||
        response.data.stat === undefined
    ) {
        return false;
    }

    return true;
};

export const isOrderRecordByBarcodeValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || response.data.item === undefined || response.data.item.id === undefined) {
        return false;
    }

    return true;
};

export const isHistoryOrderRecordByBarcodeValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || response.data.item === undefined) {
        return false;
    }

    if (
        response.data.item.product === undefined ||
        response.data.item.fandeck === undefined ||
        response.data.item.color === undefined ||
        response.data.item.colorInFandeck === undefined ||
        response.data.item.formula === undefined ||
        response.data.item.customer === undefined ||
        response.data.item.baseInProduct === undefined ||
        response.data.item.base === undefined ||
        response.data.item.stat === undefined
    ) {
        return false;
    }

    return true;
};

export const isGetFormulaDataFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.color === undefined || response.data.base === undefined) {
        return false;
    }

    if (
        response.data.formula === undefined ||
        response.data.formula.colorants === undefined ||
        response.data.formula.moreInfoDetailed === undefined
    ) {
        return false;
    }

    if (response.data.marginList === undefined) {
        return false;
    }

    if (response.data.marginList.custom === undefined || !Array.isArray(response.data.marginList.custom)) {
        return false;
    }

    if (response.data.marginList.default === undefined || !Array.isArray(response.data.marginList.default)) {
        return false;
    }

    if (response.data.packageList === undefined || !Array.isArray(response.data.packageList)) {
        return false;
    }

    if (response.data.local === undefined) {
        return false;
    }

    return true;
};

export const isGetCalculatedFormulaFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || response.data === null) {
        return false;
    }

    if (response.data.isLocal === undefined) {
        return false;
    }

    if (response.data.color === undefined || response.data.color === null) {
        return false;
    }

    if (
        response.data.formula === undefined ||
        response.data.formula === null ||
        response.data.formula.id === undefined ||
        response.data.formula.colorantAmountsByUnits === undefined ||
        response.data.formula.colorantAmountsByUnits === null ||
        response.data.formula.colorantAmountsByUnits.ml === undefined ||
        response.data.formula.colorantAmountsByUnits.g === undefined ||
        response.data.formula.colorantAmountsByUnits.shots === undefined ||
        response.data.formula.moreInfoDetailed === undefined
    ) {
        return false;
    }

    if (response.data.base === undefined || response.data.base === null) {
        return false;
    }

    if (response.data.baseInProduct === undefined || response.data.baseInProduct === null) {
        return false;
    }

    if (response.data.packages === undefined || !Array.isArray(response.data.packages)) {
        return false;
    }

    if (response.data.package === undefined) {
        return false;
    }

    return true;
};

export const isGetFormulaMetaDataFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.priceList === undefined || !Array.isArray(response.data.priceList)) {
        return false;
    }

    return true;
};

export const isGetFormulaMetaData2FormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (
        response.data.priceList === undefined ||
        response.data.printData === undefined ||
        response.data.tmcData === undefined
    ) {
        return false;
    }

    return true;
};

export const isRecalculateFormulaFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (
        response.data === undefined ||
        response.data === null ||
        response.data.colorants === undefined ||
        response.data.colorants === null ||
        response.data.colorantAmountsByUnits === undefined ||
        response.data.colorantAmountsByUnits === null ||
        response.data.colorantAmountsByUnits.ml === undefined ||
        response.data.colorantAmountsByUnits.g === undefined ||
        response.data.colorantAmountsByUnits.shots === undefined
    ) {
        return false;
    }

    return true;
};

export const isGetDatabasesListFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || !Array.isArray(response.data)) {
        return false;
    }

    return true;
};

export const isGetActiveDatabaseFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || response.data === null) {
        return false;
    }

    return true;
};

export const isGetColorsBySpectroFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || response.data.colors === undefined) {
        return false;
    }

    return Array.isArray(response.data.colors);
};

export const isGetDatabaseImageFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    return true;
};

export const isAnyDatabaseAvailable = (list) => {
    for (let db of list) {
        if (db.ok) {
            return true;
        }
    }

    return false;
};

export const needAnyDatabaseUpdate = (list) => {
    for (let db of list) {
        if (
            db.status === databaseStatuses.MAIN_AND_LOCAL_UPDATE_NEEDED ||
            db.status === databaseStatuses.MAIN_UPDATE_NEEDED ||
            db.status === databaseStatuses.LOCAL_UPDATE_NEEDED
        ) {
            return true;
        }
    }

    return false;
};

export const checkServerVersion = (response) => {
    let version = changelogService.getLastServerVersion();
    let clientServerVersion = version.split(".");
    let serverVersion = response.data.server.version.split(".");
    if (clientServerVersion.length !== serverVersion.length) {
        return false;
    }
    for (let i = 0; i < clientServerVersion.length; i++) {
        if (Number(serverVersion[i]) < Number(clientServerVersion[i])) {
            return false;
        }
        if (Number(serverVersion[i]) > Number(clientServerVersion[i])) {
            return true;
        }
    }
    return true;
};

export const checkDatabaseCompatability = (response) => {
    if (
        response.data.db.local.minId > response.data.server.id ||
        response.data.db.main.minId > response.data.server.id
    ) {
        return false;
    }

    return true;
};

export const isGetPackagesByParamsFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }
    if (response.data === undefined) {
        return false;
    }

    if (response.data.packageList === undefined || !Array.isArray(response.data.packageList)) {
        return false;
    }

    return true;
};

export const isAddFavoriteFolderFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || response.data.id === undefined) {
        return false;
    }

    return true;
};

export const parseAddFavoritesFolderResponse = (response) => {
    if (response.result !== undefined && response.result === resultCodes.RESULT_OK) {
        return response.data.folderId;
    }

    return -1;
};

export const parseSpectroFormulas = (response) => {
    if (response.result !== 0 || response.data === undefined || response.data === null) {
        return [];
    }

    return response.data.colors;
};

export const isGetOrdersFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.orders === undefined) {
        return false;
    }

    return true;
};

export const isOrderDetailFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (!response.data) {
        return false;
    }

    if (!response.data.order) {
        return false;
    }

    if (
        response.data.order.id === undefined ||
        response.data.order.identifier === undefined ||
        response.data.order.status === undefined ||
        response.data.order.brand === undefined
    ) {
        return false;
    }

    return true;
};

export const isGetProductByNameFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.product === undefined || response.data.product === null) {
        return false;
    }

    return true;
};

export const isGetColorByNameFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.color === undefined || response.data.color === null) {
        return false;
    }

    return true;
};

export const isGetFandeckByNameFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.fandeck === undefined || response.data.fandeck === null) {
        return false;
    }

    return true;
};

export const isGetPackageByNameFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.package === undefined || response.data.package === null) {
        return false;
    }

    return true;
};

export const isGetCustomersByParamsFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.customerList === undefined || !Array.isArray(response.data.customerList)) {
        return false;
    }

    return true;
};

export const isGetCustomerByNameFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.customer === undefined || response.data.customer === null) {
        return false;
    }

    return true;
};

export const isGetItemByBarcodeFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.itemType === undefined || response.data.item === undefined) {
        return false;
    }

    return true;
};

export const isInitDataFormatValid = (data) => {
    if (data === undefined) {
        return false;
    }

    if (
        data.serverInfo === undefined ||
        data.serverInfo.uuid === undefined ||
        data.serverInfo.name === undefined ||
        data.serverInfo.version === undefined
    ) {
        return false;
    }

    if (data.posInfo === undefined) {
        return false;
    }

    if (data.currency === undefined) {
        return false;
    }

    if (data.plugins === undefined || !Array.isArray(data.plugins)) {
        return false;
    }

    if (data.productsNums === undefined || data.fandecksNums === undefined) {
        return false;
    }

    return true;
};

export const isServerConfigurationValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.Multicast === undefined || response.data.Multicast.enabled === undefined) {
        return false;
    }

    return true;
};

export const isGetLicensingInfoFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (
        response.data === undefined ||
        response.data === null ||
        typeof response.data.computerId !== "string" ||
        typeof response.data.uuid !== "string"
    ) {
        return false;
    }

    return true;
};

export const isAddCustomFormulaValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (
        response.data.colorInFandeck === undefined ||
        response.data.colorInFandeck === null ||
        response.data.colorInFandeck.color === undefined ||
        response.data.colorInFandeck.color === null
    ) {
        return false;
    }

    return true;
};

export const isPricingGetDataFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    return true;
};

export const isGetPrintDataFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.printData === undefined) {
        return false;
    }

    return true;
};

export const isGetFileFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (response.data.id === undefined || response.data.data === undefined || response.data.mimeType === undefined) {
        return false;
    }

    return true;
};

export const isGetFilePreviewFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (
        response.data.fileId === undefined ||
        response.data.page === undefined ||
        response.data.data === undefined ||
        response.data.mimeType === undefined
    ) {
        return false;
    }

    return true;
};

export const isPrepareFileFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    return response.data !== undefined && response.data !== null && response.data.id !== undefined;
};

export const isImageFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    if (
        typeof response.data !== "object" ||
        response.data === null ||
        response.data.imageId === undefined ||
        response.data.imageId === null ||
        response.data.data === undefined ||
        response.data.data === null ||
        response.data.mimeType === undefined ||
        response.data.mimeType === null
    ) {
        return false;
    }

    return true;
};

export const getFormattedMoreInfo = (formula) => {
    if (
        formula === undefined ||
        formula === null ||
        formula.moreInfoDetailed === undefined ||
        formula.moreInfoDetailed === null
    ) {
        return null;
    }

    return formula.moreInfoDetailed.textFormatted;
};

export const isColorInFandeckValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || response.data === null) {
        return true;
    }

    if (
        response.data.code === undefined ||
        response.data.rgb === undefined ||
        response.data.color === undefined ||
        response.data.color === null ||
        response.data.fandeck === undefined
    ) {
        return false;
    }

    return true;
};

export const isGetFileInfoValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (
        response.data === undefined ||
        response.data === null ||
        response.data.id === undefined ||
        response.data.numPages === undefined
    ) {
        return false;
    }

    return true;
};

export const isGetDisabledValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || response.data === null || response.data.numDisabledItems === undefined) {
        return false;
    }

    return true;
};

export const isGetAllTintometricSystemsValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK || !Array.isArray(response.data)) {
        return false;
    }

    return true;
};

export const isGetBarcodeValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK || response.data === undefined || response.data === null) {
        return false;
    }

    return true;
};

export const isGetColorfilesFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK || response.data === undefined || !Array.isArray(response.data)) {
        return false;
    }

    return true;
};

export const isGetColorfileDetailFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || response.data.bases === undefined || !Array.isArray(response.data.bases)) {
        return false;
    }

    return true;
};

export const isValidateFormulaFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    return Array.isArray(response.data) && response.data.length === 3;
};

export const isColorInFandeckDataFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (
        response.data === undefined ||
        response.data === null ||
        response.data.colorInFandeck === null ||
        response.data.colorInFandeckData === null
    ) {
        return false;
    }

    return true;
};

export const isServiceDepartmentsFormatValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || !Array.isArray(response.data)) {
        return false;
    }

    return true;
};

const getEmptyStatDetails = () => {
    return {
        active: false,
        product: null,
        fandeck: null,
        color: null,
        formula: null,
        base: null,
        bipp: null,
        package: null,
        margin: null,
        customer: null,
        buildingSite: null,
        dispenseNote: null,
        numCanDone: 0,
        numCanTotal: 0,
        packageList: [],
        priceList: [],
        productFileList: [],
        printData: null,
        tmcData: null,
        infoData: null,
        moreInfoText: null,
        moreInfoData: null,
        history: null,
        alternative: null,
        validation: null,
        spectralData: null,
        compatibleServerList: []
    };
};

export const processQuickTintFromStatDetails = (
    data,
    shotsName,
    allColorantList,
    colorantPanelOrderBy,
    generateColorPreview
) => {
    data.color.id = config.QUICK_TINT_ID;
    data.color.displayName = translate("general.quickTint");

    let statDetails = getEmptyStatDetails();
    statDetails.color = modelHelper.mapColorDataToObject(
        data.color.id,
        data.color.name,
        data.color.displayName,
        data.color.code,
        generateColorPreview ? data.stat.colorRgb : null,
        data.color.isLocal
    );
    statDetails.formula = modelHelper.buildFormulaObject(
        data.formula.id,
        data.color,
        generateColorPreview ? data.stat.colorRgb : null,
        data.formula.colorantAmountsByUnits,
        data.formula.colorantAmountsByUnits,
        shotsName,
        allColorantList,
        data.stat.scaling === null ? 1 : data.stat.scaling,
        colorantPanelOrderBy
    );
    statDetails.numCanDone = data.stat.dispensedPackageCount;
    statDetails.numCanTotal = data.stat.packageCount;
    statDetails.packageList = [];
    statDetails.priceList = modelHelper.mapFormulaPricesToObjects(data.stat.prices);
    statDetails.printData = data.stat.printData;
    statDetails.tmcData = data.stat.tmcData;
    statDetails.infoData = data.stat.infoData;
    statDetails.moreInfoText = getFormattedMoreInfo(data.formula);
    statDetails.moreInfoData = modelHelper.mapFormulaMoreInfoToObjects(data.formula);
    statDetails.compatibleServerList = [];

    return statDetails;
};

const getOriginalFormula = (statsType, originalColorants, dispensedColorants, availableFormulas) => {
    if (originalColorants !== null) {
        return originalColorants;
    }

    if (
        statsType === statsTypes.UNDEFINED ||
        statsType === statsTypes.MAIN_FORMULA ||
        statsType === statsTypes.LOCAL_FORMULA ||
        statsType === statsTypes.QUICK_TINT ||
        statsType === statsTypes.ORDER ||
        !Array.isArray(availableFormulas)
    ) {
        return dispensedColorants;
    }

    let availableFormula = null;

    let originalFormula = null;
    for (availableFormula of availableFormulas) {
        if (originalFormula === null) {
            originalFormula = availableFormula;
        }

        if (availableFormula.formula.created > originalFormula.formula.created) {
            originalFormula = availableFormula;
        }
    }

    if (originalFormula === null) {
        return dispensedColorants;
    }

    return originalFormula.formula.colorantAmountsByUnits;
};

const processFormulaFromStatDetails = (data, shotsName, allColorantList, colorantPanelOrderBy) => {
    let formula = modelHelper.buildFormulaObject(
        data.formula.id,
        data.color,
        data.colorInFandeck.rgb === null ? data.color.rgb : data.colorInFandeck.rgb,
        getOriginalFormula(
            data.type,
            data.originalColorants,
            data.formula.colorantAmountsByUnits,
            data.availableFormulas
        ),
        data.formula.colorantAmountsByUnits,
        shotsName,
        allColorantList,
        data.stat.scaling === null ? 1 : data.stat.scaling,
        colorantPanelOrderBy
    );

    formula.created = data.formula.created === null ? null : new Date(data.formula.created);
    formula.updated = data.formula.updated === null ? null : new Date(data.formula.updated);
    formula.enabled = data.formula.enabled;
    formula.verified = data.formula.verified;
    formula.rejected = data.formula.rejected;
    formula.notAvailable = data.formula.notAvailable;
    formula.statsType = data.stat.colorsStatsTypeId;
    formula.cifId = data.colorInFandeck !== null ? data.colorInFandeck.id : null;
    formula.bipId = data.baseInProduct !== null ? data.baseInProduct.id : null;
    formula.colorantsGroupId = data.formula.colorantsGroupId;
    formula.destinationId = data.formula.destinationId;
    formula.formulaSourceId = data.formula.formulaSourceId;
    formula.formulaTypeId = data.formula.formulaTypeId;

    if (
        formula.statsType === null ||
        formula.statsType === statsTypes.UNDEFINED ||
        formula.statsType === statsTypes.MAIN_FORMULA ||
        formula.statsType === statsTypes.LOCAL_FORMULA ||
        formula.statsType === statsTypes.QUICK_TINT ||
        formula.statsType === statsTypes.ORDER
    ) {
        return formula;
    }

    if (
        formula.statsType === statsTypes.MODIFIED_MAIN_FORMULA ||
        formula.statsType === statsTypes.MODIFIED_LOCAL_FORMULA
    ) {
        if (formula.scaling !== 1) {
            return formula;
        }

        return formula.modifyFormula(
            modelHelper.getColorantListFromFormula(
                data.formula.colorantAmountsByUnits.ml,
                allColorantList,
                settings.UNIT_ML,
                colorantPanelOrderBy
            ),
            modelHelper.getColorantListFromFormula(
                data.formula.colorantAmountsByUnits.g,
                allColorantList,
                settings.UNIT_G,
                colorantPanelOrderBy
            ),
            modelHelper.getColorantListFromFormula(
                data.formula.colorantAmountsByUnits.shots,
                allColorantList,
                shotsName,
                colorantPanelOrderBy
            )
        );
    }

    if (data.cumulativeColorants === null) {
        return formula;
    }

    return formula.modifyFormula(
        modelHelper.getColorantListFromFormula(
            data.cumulativeColorants.ml,
            allColorantList,
            settings.UNIT_ML,
            colorantPanelOrderBy
        ),
        modelHelper.getColorantListFromFormula(
            data.cumulativeColorants.g,
            allColorantList,
            settings.UNIT_G,
            colorantPanelOrderBy
        ),
        modelHelper.getColorantListFromFormula(
            data.cumulativeColorants.shots,
            allColorantList,
            shotsName,
            colorantPanelOrderBy
        )
    );
};

export const processDataFromStatDetails = (
    data,
    shotsName,
    colorantList,
    colorantPanelOrderBy,
    totalCntAmounts,
    overfill,
    minDosableAmount,
    batchNumber,
    colorantBaseRules,
    availableColorantAmounts,
    tintometricSystemsEnabled,
    generateColorPreview
) => {
    if (data.type === statsTypes.QUICK_TINT) {
        return processQuickTintFromStatDetails(
            data,
            shotsName,
            colorantList,
            colorantPanelOrderBy,
            generateColorPreview
        );
    }

    if (data.fandeck !== null && data.fandeck.id === null) {
        data.fandeck.id = config.UNKNOWN_ID;
    }

    if (data.color.id === null) {
        if (data.colorInFandeck.color !== null && data.colorInFandeck.color.id !== null) {
            data.color.id = data.colorInFandeck.color.id;
        }

        if (data.color.id === null) {
            data.color.id = config.UNKNOWN_ID;
        }
    }

    let statDetails = getEmptyStatDetails();
    statDetails.product = data.product?.id ? modelHelper.mapProductToObject(data.product) : null;
    statDetails.fandeck = modelHelper.mapFandeckToObject(data.fandeck);
    statDetails.color = modelHelper.mapColorDataToObject(
        data.color.id,
        data.color.name,
        data.color.displayName,
        data.colorInFandeck.code === null ? data.color.code : data.colorInFandeck.code,
        data.colorInFandeck.rgb === null ? data.color.rgb : data.colorInFandeck.rgb,
        data.color.isLocal
    );
    statDetails.margin = modelHelper.mapMarginToObject(data.margin);
    statDetails.customer = modelHelper.mapCustomerToObject(data.customer);
    statDetails.buildingSite = data.stat.buildingSite;
    statDetails.dispenseNote = data.stat.moreInfo;
    statDetails.numCanDone = data.stat.dispensedPackageCount === null ? 0 : data.stat.dispensedPackageCount;
    statDetails.numCanTotal = data.stat.packageCount;
    statDetails.packageList = modelHelper.mapBippToObjects(data.packages);
    statDetails.priceList = modelHelper.mapFormulaPricesToObjects(data.prices);
    statDetails.productFileList = modelHelper.mapFilesToObjects(data.productFiles);
    statDetails.printData = modelHelper.formatPrintData(data.printData);
    statDetails.tmcData = data.stat.tmcData;
    statDetails.infoData = data.stat.infoData;
    statDetails.moreInfoText = getFormattedMoreInfo(data.formula);
    statDetails.moreInfoData = modelHelper.mapFormulaMoreInfoToObjects(data.formula);
    statDetails.validation = !Array.isArray(data.stat.formulaValidationErrors)
        ? null
        : modelHelper.mapFormulaValidationErrorsToObject(
              data.stat.formulaValidationErrors,
              rcc.RCC_VALIDATION_OK,
              totalCntAmounts,
              overfill,
              minDosableAmount,
              batchNumber,
              colorantBaseRules,
              availableColorantAmounts
          );
    statDetails.compatibleServerList = Array.isArray(data.compatibleServers)
        ? modelHelper.mapAvailableServersToObject(data.compatibleServers)
        : [];

    statDetails.formula = processFormulaFromStatDetails(data, shotsName, colorantList, colorantPanelOrderBy);

    statDetails.base = data.base?.id ? modelHelper.mapBaseToObject(data.base, data.baseInProduct) : null;
    statDetails.bipp = modelHelper.mapBaseInProductPackageToObject(data.baseInProductPackage);

    if (data.stat.reflData !== null) {
        statDetails.spectralData = modelHelper.mapSpectralDataToObject(
            data.colorInFandeck.rgbTuple === null ? [0, 0, 0] : data.colorInFandeck.rgbTuple,
            data.stat.lab,
            [0, 0, 0],
            data.colorInFandeck.rgb === null ? data.color.rgb : data.colorInFandeck.rgb,
            modelHelper.formatReflData(data.stat.reflData)
        );
    }

    if (data.package !== null) {
        if (data.package.id !== null) {
            for (let statsPackageItem of statDetails.packageList) {
                if (data.package.id === statsPackageItem.package.id) {
                    statDetails.package = statsPackageItem;
                }
            }
        } else {
            if (statDetails.bipp !== null) {
                statDetails.bipp = statDetails.bipp.updatePackage(
                    modelHelper.mapCustomPackageToObject(data.stat, data.formula.baseFillVolumeMl)
                );
                statDetails.package = statDetails.bipp;
            }
        }
    }

    let historicalFormulas = [];
    let alternativeFormulas = [];
    for (let item of modelHelper.mapHistoricalFormulas(
        data.availableFormulas,
        shotsName,
        colorantList,
        colorantPanelOrderBy
    )) {
        if (item.historical || !tintometricSystemsEnabled) {
            historicalFormulas.push(item);
        }

        if (!item.historical && tintometricSystemsEnabled) {
            alternativeFormulas.push(item);
        }
    }

    if (data.hasFormulaHistory) {
        statDetails.history = historicalFormulas;
    }

    if (data.hasFormulaAlternatives) {
        statDetails.alternative = alternativeFormulas;
    }

    statDetails.active = true;

    if (
        statDetails.product === null ||
        statDetails.fandeck === null ||
        statDetails.color === null ||
        statDetails.formula === null ||
        statDetails.base === null ||
        statDetails.base.baseInProductId === config.UNKNOWN_ID ||
        statDetails.bipp === null
    ) {
        statDetails.active = false;
    }

    return statDetails;
};

export const processDataFromBarcode = (
    data,
    shotsName,
    allColorantList,
    colorantPanelOrderBy,
    totalCntAmounts,
    overfill,
    minDosableAmount,
    batchNumber,
    colorantBaseRules,
    availableColorantAmounts
) => {
    try {
        if (data.product !== null && data.product.id === null) {
            data.product.id = config.UNKNOWN_ID;
        }

        if (data.fandeck !== null && data.fandeck.id === null) {
            data.fandeck.id = config.UNKNOWN_ID;
        }

        if (data.base !== null && data.base.id === null) {
            data.base.id = config.UNKNOWN_ID;
        }

        let statDetails = processDataFromStatDetails(
            data,
            shotsName,
            allColorantList,
            colorantPanelOrderBy,
            totalCntAmounts,
            overfill,
            minDosableAmount,
            batchNumber,
            colorantBaseRules,
            availableColorantAmounts
        );

        if (statDetails.product.id === config.UNKNOWN_ID || statDetails.fandeck.id === config.UNKNOWN_ID) {
            statDetails.active = false;
        }

        return statDetails;
    } catch (e) {
        windowService.logError("6BDE59255362C61", e.message);

        return getEmptyStatDetails();
    }
};

export const isCreateTicketResponseValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined) {
        return false;
    }

    return true;
};

export const isTicketingResponseValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    if (response.data === undefined || response.data === null) {
        return false;
    }

    return Array.isArray(response.data.data) && typeof response.data.count === "number";
};

export const isBooleanResponseValid = (response) => {
    if (response.result !== resultCodes.RESULT_OK) {
        return false;
    }

    return !!response.data;
};

export const handleGlobalInitDataResponse = (response) => {
    return [
        {
            type: actionTypes.SAVE_POS_FORM_INFO,
            payload: {
                posInfo: response.data.posInfo
            }
        },
        {
            type: actionTypes.SAVE_SERVER_INFO,
            payload: {
                data: response.data.serverInfo
            }
        },
        {
            type: actionTypes.SAVE_PRIMARY_CURRENCY,
            payload: {
                currency: response.data.currency
            }
        },
        {
            type: actionTypes.SAVE_SERVER_PLUGINS,
            payload: {
                plugins: response.data.plugins
            }
        },
        {
            type: actionTypes.SAVE_DISABLED_PRODUCTS,
            payload: {
                disabledProducts: response.data.productsNums.numDisabledItems
            }
        },
        {
            type: actionTypes.SAVE_DISABLED_FANDECKS,
            payload: {
                disabledFandecks: response.data.fandecksNums.numDisabledItems
            }
        },
        {
            type: actionTypes.STOCK_SAVE_WARNING,
            payload: {
                stockWarning: response.data.stockWarning
            }
        },
        {
            type: actionTypes.SAVE_TINTOMETRIC_SYSTEM,
            payload: {
                tintometricSystem: response.data.tintometricSystem
            }
        }
    ];
};
